export function isWorkspaceManagerRole(role: string): boolean {
  return role === 'owner' || role === 'admin'
}
